<template>
    <div v-if="!confirm_basket">
        <div v-if="(!checkout || (checkout && !$root.authenticated)) && (page == 'auth.register' || page == 'auth.login' || page == 'cart.details.confirm')">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="alerts" id="signup-alert">
                    <span class="content">
                        {{ locale.text_info_sign_up_description }}
                    </span>

                    <a @click="$router.push({ name: 'auth.register', query: { back_route: ($route.query.hasOwnProperty('back_route') ? $route.query.back_route : $route.name ) } })" class="cta-button red" v-if="page == 'auth.login'">Sign up</a>
                    <a @click="$router.push({ name: 'auth.login', query: { back_route: ($route.query.hasOwnProperty('back_route') ? $route.query.back_route : $route.name ) } })" class="cta-button blue" v-else>Sign in</a>
                </div>
            </div>
        </div>

        <div class="form">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="box-layout-inner">

                        <transition name="fade">
                            <login-form @authenticated="authenticated" v-if="page == 'auth.login'"></login-form>
                            <password-form v-else-if="page == 'auth.password'"></password-form>
                            <reset-form v-else-if="page == 'auth.reset'"></reset-form>
                            <register-form @registered="authenticated" v-else></register-form>
                        </transition>
                    </div>
                </div>

        </div>
    </div>
    <div v-else>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div class="box-layout-inner">
                    <div class="title-block">
                        <div class="col-md-12">{{ locale.text_alert_decision_title }}</div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" v-for="(booking, key) in bookings">
                <div class="box-layout-inner booking-choice">
                    <div class="title-block-alt">
                        <div class="alt-container">
                            <span v-html="'Basket created '+booking.booking_date.toDate().toDateString(true)"></span>
                            <b>{{ currencyFormat(booking.total_cost, true) }}</b>
                        </div>
                    </div>

                    <div class="content-block">
                        <span class="participant-list">
                            <p v-for="venue in booking.collection">
                                {{ venue.venue_name }}
                                <ul class="date-list">
                                    <li v-for="item in venue.items"><span v-html="(new Date()).formatRange(item.days_attending) + '<br /><b>' + item.participant_full_name+'</b>'"></span></li>
                                </ul>
                            </p>
                        </span>
                    </div>

                    <div class="full-width-cta">
                        <a class="cta-button" :class="{ 'blue': booking.user_id != null, 'red': booking.user_id == null }" @click="confirm(booking.user_id == null ? true : false)" v-html="(booking.user_id != null ? 'Continue with old basket' : 'Continue with current basket')"></a>
                        <p v-if="booking.hasOwnProperty('is_editing') && booking.is_editing == true">{{ locale.text_alert_decision_edit_warning }}</p>
                    </div>

                </div>
            </div>
    </div>
</template>

<script>
    export default {
        props: ['checkout'],
        data () {
            return {
                previous: [],
                stranded_participants: [],

                confirm_basket: false,
                bookings: [],

                user: null,
            }
        },
        computed: {
            isCheckout: function () {
                return this.$route.name != 'auth.register';
            },
            page: function () {
                return this.$route.name;
            },
            title: function () {
                if(this.checkout && this.$root.authenticated && this.page == 'auth.register')
                    return this.$root.locale.miscellaneous.page_headings.cart.confirm_account_details;

                switch(this.$route.name) {
                    case 'auth.register':
                        return this.$root.locale.miscellaneous.page_headings.auth.signup;
                    case 'auth.login':
                        return this.$root.locale.miscellaneous.page_headings.auth.login;
                    case 'auth.password':
                    case 'auth.reset':
                        return this.$root.locale.miscellaneous.page_headings.auth.forgotten_password;
                    case 'cart.details.confirm':
                        if(this.$root.authenticated)
                            return this.$root.locale.miscellaneous.page_headings.cart.confirm_account_details;
                        else
                            return this.$root.locale.miscellaneous.page_headings.auth.signup;
                }
            },
            locale: function () {
                return this.$root.locale.account.register;
            }
        },
        components: {
            'register-form': require('./forms/register.vue'),
            'login-form': require('./forms/login.vue'),
            'password-form': require('./forms/password.vue'),
            'reset-form': require('./forms/reset.vue')
        },
        watch: {
            '$route' (to) {
                /**
                 * Setting the headers
                 **/
                this.$root.headers = {
                    navigate: {
                        back: true
                    },
                    title: this.title,

                }
                this.checkAuth();
            },
            //WATCH THE BASKETS ARRAY AND FORMAT IT TO BE A LIST OF PARTICIPANTS WITH THEIR ITEMS
            'bookings' () {
                this.bookings.forEach((basket, key) => {
                    var participant_bookings = [];
                    var items = (basket.booking_items != undefined ? basket.booking_items : basket[0].items);
                    items.forEach(function ( item ) {
                        let existing = participant_bookings[item.venue_id];
                        participant_bookings[item.venue_id] = {
                            user_id: item.user_id,
                            venue_name: item.venue_name + ' (' + item.venue_town + ')',
                            currency_unit: basket.currency_unit,
                            total_cost: item.booking_item_total_cost,
                            items: ( existing ? existing['items'].concat([item]) : [item] )
                        };
                    });

                    this.bookings[key].collection = participant_bookings.filter(item => item != undefined);

                })
            }
        },
        methods: {
            currencyFormat: function ( value, show_minus = false) {
                return (value < 0 && show_minus ? '- ' : '') + '£' + Math.abs(value).toFixed(2);
            },
            checkAuth: function () {

                axios.get('/camp-booking/users/current')
                    .then(response => {
                        if(response.data.data.user_id) {
                            if(!this.checkout) {
                                this.$emit('authenticated', response.data.data)

                                //It will be redirected back one if no methods have been triggered above to redirect.
                                this.$router.push({ name: 'account.overview'} );
                            }
                        }
                    })
            },
            authenticated: function (user) {
                this.user = user;

                //Checking if there is a booking in the cache that we should assign to this user
                var authBookingId = null;
                var authOriginalId = null;
                if(user.user_id != undefined && user.user_id != null)
                    axios.get('/camp-booking/users/'+user.user_id+'/basket')
                        .then(response => {
                            //Checking if the authenticted user has any items on their basket that would potentiaally be replaced
                            if(response.data.data.number_of_items_in_basket > 0)
                                authBookingId = response.data.data.booking_id;
                                authOriginalId = response.data.data.origional_booking_id;
                            var booking_id = this.$root.getCookie('kingscamps_booking_id');
                            //Firstly this is checking whether this is checkout or not, if so continue with guest booking and assign to user
                            //Then checking if the guest actually has a booking_id which is valid.
                            //Then checking if the guests basket has got any items in the basket (hasn't updated the basket count just yet so this will still contain the guest booking count)
                            //Then checking the users booking id is valid
                            if (!this.checkout && booking_id > 0 && this.$root.booking_user_id == 'null' && this.$root.number_of_items_in_basket > 0 && authBookingId != null) {
                                this.bookings = [];
                                //Getting the authenticated users booking
                                axios.get('/camp-booking/bookings/'+authBookingId)
                                    .then(response => {
                                        this.bookings.push(Object.assign(response.data.data, {is_editing: authOriginalId != null}));
                                    })
                                //Getting the guest booking
                                axios.get('/camp-booking/bookings/'+this.$root.getCookie('kingscamps_booking_id'))
                                    .then(response => {
                                        this.bookings.push(response.data.data);
                                    })
                                this.confirm_basket = true;
                            } else {
                                this.confirm(1);
                            }
                        })
                else
                    this.confirm(0);

            },
            confirm: function (check) {
                var user = this.user;
                var assigned = false;

                if(check) {
                    var booking_id = this.$root.getCookie('kingscamps_booking_id');
                    if(booking_id != null && booking_id != 'null' && Number.isInteger(parseInt(booking_id)) && parseInt(booking_id) > 0) {
                        axios.post('/camp-booking/bookings/' + booking_id + '/assign', {
                            user_id: user.user_id
                        })
                        assigned = true;
                    } else {
                        this.$root.setBookingId();
                    }
                } else {
                    this.$root.setBookingId();
                }

                /** Updating the basket count **/
                this.$root.updateBasketCount();


                this.$emit('authenticated', user);

                setTimeout(() => {
                    if(this.$route.query.hasOwnProperty('back_route') && this.$route.query.back_route) {
                        this.$router.push({ name: this.$route.query.back_route });
                    } else if(this.$route.query.hasOwnProperty('back') && this.$route.query.back && !this.checkout) {
                        window.location.replace('/#'+this.$route.query.back);
                    } else if(!this.checkout) {
                        this.$router.push({name: 'account.overview'});
                    }
                }, 2000)
            }
        },
        created () {
            window.router = this.$router;
            window.route = this.$route;
            /**
             * Password validation regex
             **/
            this.$validator.remove('password');// Want to remove it incase it already exists.
            this.$validator.extend('password', {
                getMessage: field => this.locale.text_password_error_message,
                validate: value => Array.isArray(value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{4,}$/))
            });

            this.checkAuth();

            /**
             * Setting the headers
             **/
            this.$root.headers = {
                navigate: {
                    back: true
                },
                title: this.title,

            }
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// auth.vue?15e10fa5